// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-text {
  color: green;
}

.clickable-navigation-text {
  cursor: pointer;
}

.active-navigation-text {
  font-weight: bold;
}

.disabled-navigation-text {
  color: gray;
}

.col {
  display: flex;
  text-align: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/navigation-tabs/navigation-tabs.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AAEE;EACE,eAAA;AACJ;;AAEE;EACE,iBAAA;AACJ;;AAEE;EACE,WAAA;AACJ;;AAEE;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;AACJ","sourcesContent":[".navigation-text {\r\n    color: green;\r\n  }\r\n  \r\n  .clickable-navigation-text {\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .active-navigation-text {\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .disabled-navigation-text {\r\n    color: gray;\r\n  }\r\n\r\n  .col{\r\n    display: flex;\r\n    text-align: center;\r\n    justify-content: center;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
